module.exports = __webpack_public_path__ + "img/1-3.33e61d44.svg";